import { DEFAULT_PATHS } from 'config.js';
import { USER_ROLE } from 'constants.js';
import { lazy } from 'react';

const consultants = {
  consultant: lazy(() => import('views/consultants/ConsultantsPage')),
};
const appRoot = DEFAULT_PATHS.APP.endsWith('/')
  ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length)
  : DEFAULT_PATHS.APP;

const consultantsRoute = {
  path: `${appRoot}/consultants`,
  exact: true,
  icon: 'user',
  label: 'commons.consultants',
  component: consultants.consultant,
  protected: true,
  roles: [USER_ROLE.Admin],
  to: `${appRoot}/consultants`,
};

export default consultantsRoute;
